<template>
  <div
    class="my-1 pt-3 -mx-2 px-5 shrink-0 select-none text-xs text-gray-400 first:mt-0 first:pt-0 border-t border-t-gray-700 first:border-t-transparent"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup></script>
